import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import * as Helpers from 'helpers';
import * as Icon from 'components/Icon';

import classes from './DownloadV2.module.scss';

interface IProps {
  label?: string;
  fileName: string;
  downloadApiUrl: string;
}

const Download: React.FC<IProps> = ({ label = 'File', fileName, downloadApiUrl }) => {
  const [percent, setPercent] = useState<number>(0);
  const { t } = useTranslation();

  return (
    <div
      className={classes.wrapper}
      onClick={() => {
        Helpers.downloadFileV2({
          fileName,
          downloadApiUrl,
          onDownloadProgress: val => setPercent(val),
          endDownloadProgress: () => setTimeout(() => setPercent(0), 1000)
        });
      }}
    >
      <div className={classes.content}>
        <div className={classes.title}>{percent ? t('File_downloading') : t(label)}</div>
        {percent ? (
          <div className={classes.progress}>{percent} %</div>
        ) : (
          <div className={classes.icon}>
            <Icon.System.Download />
          </div>
        )}
      </div>
    </div>
  );
};

export default Download;
